<template>
  <div class="is-rousai-hoken detail-item">

    <div class="head"><b>労災保険</b></div>
    <p>有</p>
    
  </div>
</template>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-detail.scss';

</style>
